import { useQuinceRouter as useRouter } from '@src/modules/navigation'
import MiniPDPProductInfoPrice from '@src/quince-components/src/atoms/miniPDPProductInfoPrice/MiniPDPProductInfoPrice'
import ReviewStars from '@src/quince-components/src/atoms/reviews/reviewStars/ReviewStars'
import { getProductLink } from '@src/quince-components/src/molecules/productCard/productCard.helpers'
import Product from '@src/quince-site-common/src/domains/Product'
import { BaseProductVariant, ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import productHelper, { THIRD_PARTY } from '@src/quince-site-common/src/helpers/productHelper'
import pdpStateManager from '@src/quince-site-common/src/redux/globalStateManager/PDPStateManager'
import {
  getFestivalOfferPricePerUnit,
  getIsFinalSaleProduct,
} from '@src/quince-site-common/src/utils/festivalOffersUtility'
import { getProductPropertiesForTracking } from '@src/telemetry/getProductPropertiesForTracking'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import styles from './miniPDPProductInfo.module.scss'

export const MiniPDPProductInfo = ({
  product,
  selectedOptions,
  selectedVariant,
}: {
  product: Product
  selectedOptions: ProductVariantOption[]
  selectedVariant?: BaseProductVariant
}) => {
  const router = useRouter()
  const { savingPercentage, formattedSalePrice, formattedTraditionalPrice, formattedFestivalOfferPrice } =
    productHelper.getProductPriceDetails(product, selectedOptions)
  const festivalPricePerUnit =
    getFestivalOfferPricePerUnit({
      product,
      selectedOptions,
    }) ?? undefined

  const productLink = getProductLink(product, selectedOptions)
  const handleReviewClick = () => {
    router.push(productLink)
    pdpStateManager.setShowReviewSection({ reviewSectionInFocus: true })
    trackEvent(TELEMETRY_EVENT_NAMES.ENTER_FEEDBACK, {
      context: {
        productProperties: getProductPropertiesForTracking(product, selectedVariant?.spid?.toString()),
      },
    })
  }

  const isFinalSaleProduct = getIsFinalSaleProduct(product, selectedOptions)
  const isVariantThirdParty = selectedVariant?.vendorType === THIRD_PARTY

  return (
    <div className={styles.productInfoContainer}>
      <div className={styles.productInfo}>
        <h1 className={styles.productTitle}>{product.title}</h1>
        {product.productReviewSummary?.reviewCount && product.productReviewSummary?.reviewCount > 0 ? (
          <div onClick={handleReviewClick} className={styles.productRating}>
            <ReviewStars
              totalStars={5}
              fillStars={product.productReviewSummary?.averageRating || 0}
              fillIconClass={styles.reviewStarIcon}
              classNameIcon={styles.starIcon}
            />
            <p className={styles.reviewCount}>
              {`(`}
              <span>{product.productReviewSummary?.reviewCount}</span>
              {`)`}
            </p>
          </div>
        ) : null}
      </div>
      <MiniPDPProductInfoPrice
        product={product}
        formattedSalePrice={formattedSalePrice}
        formattedTraditionalPrice={formattedTraditionalPrice}
        savingPercentage={savingPercentage}
        formattedFestivalOfferPrice={formattedFestivalOfferPrice}
        showDiscount={true}
        pricePerServing={selectedVariant?.pricePerServing}
        traditionalPricePerServing={selectedVariant?.traditionalPricePerServing}
        festivalPricePerUnit={festivalPricePerUnit}
        hideSavings={false}
        isFinalSaleProduct={isFinalSaleProduct}
        isVariantThirdParty={isVariantThirdParty}
        selectedOptions={selectedOptions}
      />
    </div>
  )
}
